import { AfterViewInit, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, Input, OnChanges, OnInit, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { ComponentService } from '../../../services/component.service';

@Component({
  selector: 'app-nica-tab',
  templateUrl: './nica-tab.component.html',
  styleUrls: ['./nica-tab.component.css']
})
export class NicaTabComponent implements AfterViewInit,OnChanges {
  @ViewChild('container', { static:false,read: ViewContainerRef }) container: ViewContainerRef;
  @Input() component: Type<Component>;
  @Input() tabsName:string;
  @Input() itemData; 
  componentRef:any
  
  constructor(private _componentFactoryResolver:ComponentFactoryResolver, private camponentService : ComponentService) { }

  ngAfterViewInit(): void {
    
    if(this.componentRef){
      this.container.clear()
    }
   
    const factories = Array.from(this._componentFactoryResolver['_factories'].keys());
    const factoryClass = <Type<any>>factories.find((x: any) => x.name === this.component);
   

    const componentFactory: ComponentFactory<any> = this._componentFactoryResolver.resolveComponentFactory(factoryClass);
    
    setTimeout(() => {
      
      if(!this.componentRef){
        
      this.componentRef = this.container.createComponent(componentFactory);

     

      this.componentRef.instance.itemData = this.itemData;

      //this.componentRef.instance.outputEvent.subscribe(val => {
        //  this.outputFunction(val)
      //});

      //.dataFunction = 
      
      }
    }, 100);
  }

  /*ngOnDestroy(e) {
    
    //this.camponentService.destroyTabs(this.tabsName);
  }*/
  
  ngOnChanges(e){

    
    
  }

  /*outputFunction(e){
    this.camponentService.tabInfo.subscribe(tab=>{

      console.log(tab[0].component)
    })
  }*/

}
 